import styled from "styled-components";
import CommentIcon from "@mui/icons-material/Comment";
import CampaignIcon from "@mui/icons-material/Campaign";
import {
  getBackgroundColorByStatus,
  getBackgroundColorByArtProof,
} from "components/OrderCard/utils";

export const StyledCampaignIcon = styled(CampaignIcon)`
  &.MuiSvgIcon-root {
    position: absolute;
    left: -17px;
    top: -26px;
    background: black;
    padding: 4px;
    font-size: 18px;
    border-radius: 2px;
    color: white;
    cursor: pointer;
    display: none;
  }
`;

export const Body = styled.div`
  -webkit-box-shadow: 0px 0px 1px 0px rgb(9 30 66 / 31%),
    0 2px 4px -1px rgb(9 30 66 / 25%);
  -moz-box-shadow: 0px 0px 1px 0px rgb(9 30 66 / 31%),
    0 2px 4px -1px rgb(9 30 66 / 25%);
  box-shadow: 0px 0px 1px 0px rgb(9 30 66 / 31%),
    0 2px 4px -1px rgb(9 30 66 / 25%);
  flex-grow: 1;
  border-radius: 2px;
  cursor: pointer;
  position: relative;
  border-left: 2px solid ${({ status }) => getBackgroundColorByStatus(status)};
  transition: transform 0.2s;
`;

export const Container = styled.div`
  :hover {
    ${Body} {
      transform: scale(0.8);
    }

    ${StyledCampaignIcon} {
      display: block;
    }
  }
`;

export const Wrapper = styled.div`
  padding: ${(props) => (props?.artProof ? "10px" : "10px 10px 0")};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  align-items: center;
  margin-bottom: 10px;
`;

export const PONumber = styled.div`
  margin-bottom: 5px;
  font-weight: bold;
  color: #5e6c84;
  font-size: 14px;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const VendorName = styled.div`
  color: #172b4d;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Status = styled.div`
  background-color: ${({ status }) => getBackgroundColorByStatus(status)};
  width: fit-content;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 12px;
  color: white;
  font-weight: bold;
`;

export const UploadDate = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: #172b4d;
`;

export const InProductionDate = styled.div`
  margin-top: 5px;
  font-size: 12px;
`;

export const ShippedDate = styled.div`
  margin-top: 5px;
  font-size: 12px;
`;

export const ArtProofWrapper = styled.div`
  background-color: ${({ artProof }) => getBackgroundColorByArtProof(artProof)};
  padding: 5px;
  font-size: 12px;
  margin-top: 10px;
  color: white;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const VendorLogo = styled.div`
  background-image: url(${(props) => props?.src});
  height: 36px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 90px;
  display: flex;
  justify-content: space-between;
  padding: 5px 10px 0;
`;

export const MarkAsShipped = styled.div`
  font-size: 13px;
  padding: 8px;
  text-align: center;
  font-weight: bold;
  border: 1px solid #000;

  :hover {
    background-color: #000;
    color: #fff;
  }
`;

export const MarkShipped = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Comment = styled.div``;

export const StyledCommentIcon = styled(CommentIcon)`
  cursor: pointer;
  color: #a1a1a1;
  font-size: 20px !important;
`;

export const StyledAddCommentRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 20px;

  textarea {
    width: 100%;
  }
`;

export const MessageRow = styled.div`
  display: flex;
`;

export const StyledMessage = styled.div`
  position: relative;
  margin-bottom: 20px;
  padding: 10px;
  background-color: #a8ddfd;
  border: 1px solid #97c6e3;
  border-radius: 10px;
  font-size: 12px;
`;

export const StyledMessageContent = styled.p`
  padding-bottom: 14px;
  margin: 0;
`;

export const MessageTimeStamp = styled.div`
  position: absolute;
  font-size: 0.85em;
  bottom: 3px;
  right: 5px;
`;

export const MessageDisplayName = styled.div`
  margin-bottom: 2px;
  font-size: 12px;
  font-weight: bold;
  margin-left: 4px;
`;

export const MessageBody = styled.div`
  width: 100%; ;
`;

export const DecorationChips = styled.div`
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

const getChipColorByDates = (data) => {
  if (data?.completedDate) {
    return "#3cad87";
  }

  if (data?.inProductionDate) {
    return "#fb9518";
  }

  return "#a1a1a1";
};

export const DecorationChip = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  background-color: ${(props) => getChipColorByDates(props)};
  color: #fff;
  border-radius: 16px;
  padding: 4px;
  font-weight: bold;
`;

export const Flag = styled.img`
  width: 20px;
  height: 15px;
  margin-top: 4px;
`;
